import { createFileRoute } from '@tanstack/react-router';

import { RequireCapability } from '@/components/layout/RequireCapability';
import { RequestQueue } from '@/features/philanthropy/RequestQueue';

/**
 * Philanthropy lives at the top level, not under a league.
 *
 * The per-league screen (`/leagues/$leagueId/philanthropy`) answers "what is this league's
 * pot doing". This one answers "what is waiting for me", which is a queue across every
 * league and cannot be reached from any single one of them.
 */
export const Route = createFileRoute('/philanthropy')({
  component: Screen,
});

function Screen() {
  return (
    <RequireCapability capability="philanthropy.view">
      <div className="flex flex-col gap-4">
        <div>
          <p
            className="font-head text-tx3 m-0 text-[12px] font-semibold uppercase"
            style={{ letterSpacing: '0.18em' }}
          >
            Governance
          </p>
          <h2 className="font-head text-tx m-0 mt-0.5 text-[28px] leading-[1.05] font-semibold">
            Philanthropy
          </h2>
          <p className="text-tx2 mt-1.5 max-w-[64ch] text-[13.5px] leading-[1.55]">
            Leagues asking to raise money for their chapter. Approving one commits MESH to a
            real payout and tells every member, so read the league first — the members, when
            they joined, and whether they actually play.
          </p>
        </div>
        <RequestQueue />
      </div>
    </RequireCapability>
  );
}
